<template>
  <div id="login-card">
    <div class="d-flex flex-column text-center align-items-center">
      <h4 class="mt-0">Change Password</h4>
      <p class="text-muted">
        This is your first login to the BSP Operating System.<br />
        Please change your temporary password.
      </p>
    </div>
    <b-alert
      variant="danger"
      dismissible
      fade
      :show="error != ''"
      @dismissed="error = ''"
    >
      <i class="fas fa-exclamation-triangle mr-2"></i>{{ error }}
    </b-alert>
    <b-form @submit="onSubmit" class="d-flex flex-column text-left">
      <b-form-group id="input-group-1">
        <label for="input-1" class="mb-0">Username:</label>
        <b-form-input
          id="input-1"
          v-model="confirmUsername"
          type="text"
          class="input-readonly"
          plaintext
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-3">
        <label for="input-3" class="">New Password:</label>
        <b-input-group class="">
          <template #append>
            <b-input-group-text @click="showPass()"
              ><strong :class="[showPassword ? 'text-forecast' : 'text-muted']"
                ><font-awesome-icon
                  class="icon-width"
                  :icon="
                    showPassword ? 'far fa-eye' : 'far fa-eye-slash'
                  " /></strong
            ></b-input-group-text>
          </template>
          <b-form-input
            id="input-3"
            v-bind:type="showPassword ? 'text' : 'password'"
            v-model="form.newPass"
            placeholder="Enter your new password"
            required
          ></b-form-input>
        </b-input-group>
      </b-form-group>

      <b-button
        type="submit"
        class="btn-forecast d-flex justify-content-center align-items-center"
        ><b-spinner v-if="resetCodeLoading" small></b-spinner>
        <i v-if="!resetCodeLoading" class="fa fa-undo"></i>
        <span class="ml-2">Reset Password</span></b-button
      >
    </b-form>
    <footer class="footer footer-alt">
      <p class="text-muted">
        Back to
        <router-link to="/login" class="text-muted ml-1"
          ><b>Log In</b></router-link
        >
      </p>
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { Auth } from 'aws-amplify'

export default {
  name: 'ResetPassForce',
  data() {
    return {
      form: {
        newPass: ''
      },
      resetCodeLoading: false,
      error: '',
      showPassword: false
    }
  },
  computed: mapGetters(['confirmEmail', 'confirmUsername', 'forcePassUser']),
  methods: {
    ...mapMutations(['SET_AUTH_USER']),
    async onSubmit(event) {
      event.preventDefault()
      this.resetCodeLoading = true
      try {
        const user = await Auth.completeNewPassword(
          this.forcePassUser,
          this.form.newPass
        )
        this.resetCodeLoading = false
        this.SET_AUTH_USER(user)
        this.$router.push({ path: '/pig-info' })
      } catch (err) {
        console.log(err)
        this.error = err.message
        this.resetCodeLoading = false
      }
    },
    showPass: function () {
      this.showPassword = !this.showPassword
    }
  }
}
</script>

<style scoped></style>
